import { lighten } from '@mui/material/styles';
import { fade, darken } from '@mui/material';
export default theme => ({
  link: {
    textDecoration: 'none',
    color: theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
  },
  chart: {
    paddingLeft: 5,
  },
  graphContainer: {
    margin: 2,
    height: '300px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  spinner: {
    position: 'absolute',
    right: 5,
    top: 5,
    margin: 'auto',
  },
  noData: {
    position: 'absolute',
    right: 0,
    bottom: 80,
    left: 0,
    margin: 'auto',
  },
  noDataText: {
    whiteSpace: 'nowrap',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});
